import $ from "jquery";
import ScrollMagic from "scrollmagic";

var crisisLine = $(".crisis-line-wrapper").html();

$("#footer-outer").append(crisisLine);

$(".cta-button").each(function() {
  let text = $(this)
    .find("span")
    .text();
  let texts = text.split("|");
  $(this).html(
    `<span class="cta-button-subtext">${
      texts[0]
    }</span><span class="cta-button-text">${
      texts[1]
    }</span><span class="arrow"><span></span><span></span><span></span></span>`
  );
});

$(".crisis-line__icon").on("click", function() {
  $(this)
    .parent()
    .toggleClass("active");
});

var contentCrisisLines = document.querySelector(".crisis-line");
var body = document.querySelector("body");
var contentWrap = document.querySelector(".container-wrap");

if (contentCrisisLines) {
  // init controller
  var controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({ triggerElement: ".container-wrap" })
    .triggerHook(0)
    .setClassToggle(body, "crisis-lines--sticky") // add class toggle

    .addTo(controller);
}

$(".crisis-line")
  .closest(".wpb_row")
  .addClass("row-crisis-line");
